import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sprintf } from 'sprintf-js';
import { Enum } from './enum';
export var Breakpoint = Enum('xs', 'sm', 'md', 'lg', 'xl');
export var BreakpointValues = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Breakpoint.xs, 0), Breakpoint.sm, 552), Breakpoint.md, 768), Breakpoint.lg, 1008), Breakpoint.xl, 1280);
export var breakpointInfix = function breakpointInfix(breakpoint) {
  if (!breakpointPrev(breakpoint)) {
    return '';
  } else {
    return "::".concat(breakpoint);
  }
};
export var breakpointPrev = function breakpointPrev(breakpoint) {
  var breakpointNames = Object.keys(Breakpoint).map(function (e) {
    return Breakpoint[e];
  });
  var index = breakpointNames.indexOf(breakpoint);
  return index > 0 ? breakpointNames[index - 1] : null;
};
export var breakpointNext = function breakpointNext(breakpoint) {
  var breakpointNames = Object.keys(Breakpoint).map(function (e) {
    return Breakpoint[e];
  });
  var index = breakpointNames.indexOf(breakpoint);
  return index < breakpointNames.length ? breakpointNames[index + 1] : null;
};
export function responsiveClasses(template, props) {
  var classNames = [];
  var keys = Object.keys(props);
  if (_typeof(props) === 'object') {
    keys.forEach(function (key) {
      var cn = sprintf(template, props[key]).toLowerCase();
      classNames.push(cn + breakpointInfix(key));
    });
  } else {
    var cn = sprintf(template, props).toLowerCase();
    classNames.push(cn + breakpointInfix(props));
  }
  return classNames;
}